import React from 'react';
import { motion } from 'framer-motion';
export function StatementSection() {
  return <section className="border-b border-line" data-id="element-116" data-mp="34d1j3j6q6ml7">
      <div className="mx-auto w-full max-w-[1240px] px-5 py-16 sm:px-6 lg:px-10 lg:py-24" data-id="element-117" data-mp="34d9t93bgrdsp">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end lg:gap-12" data-id="element-118" data-mp="2zc3zd262hkhl">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-8" data-id="element-119" data-mp="2ufdnkr1apb1z">
            <div className="mb-5 flex items-center gap-3" data-id="element-120" data-mp="2gmny2cmk5o04">
              <span className="h-px w-6 bg-cyan-vip sm:w-8" data-id="element-121" data-mp="2gl2zmbx4hkwz" />
              <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-cyan-vip sm:text-[11px] sm:tracking-[0.28em]" data-id="element-122" data-mp="2bpdza6da3zzm">
                Protocolo de Apertura VIP
              </span>
            </div>
            <h1 className="max-w-4xl text-[32px] font-bold leading-[1] tracking-[-0.03em] text-white sm:text-5xl sm:leading-[0.98] sm:tracking-[-0.035em] lg:text-[68px]" data-id="element-123" data-mp="21qgdhb78mkkb">
              <span className="text-glow-white" data-id="element-124" data-mp="26jduh4ue1nuy">La Precisión no es</span>{' '}
              <span className="text-white/35" data-id="element-125" data-mp="1ruhmf7sc0auc">una opinión.</span>
              <br className="hidden sm:block" data-id="element-126" data-mp="1rs4vi54liq55" />{' '}
              <span className="text-glow-gold text-gold-vip" data-id="element-127" data-mp="1wsj71x5eoi7x">
                Es una regla matemática.
              </span>
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-4" data-id="element-128" data-mp="2phzsubyit0v6">
            <p className="max-w-md text-[14px] leading-relaxed text-white/55 sm:text-[15px]" data-id="element-129" data-mp="z5k3d2gaqa0j">
              Bienvenido a la Terminal de indicadoresvip.com. Monitorea el
              XAU/USD en tiempo real y aplica el Protocolo de Apertura VIP.
            </p>
            <a href="#acceso" className="mt-6 inline-flex items-center gap-2 border-b border-cyan-vip/40 pb-1 font-mono text-[11px] uppercase tracking-[0.18em] text-cyan-vip transition-colors duration-150 ease-out hover:border-cyan-vip focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip" data-id="element-130" data-mp="36qsntim4j7is">
              Ver el manual completo
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}